import 'react';
import { X } from 'react-feather';
import { jsx } from 'react/jsx-runtime';
import { Button } from '../button/Button.js';

const ClearButton = ({
  onClick,
  clearIcon = null,
  theme = {}
}) => {
  return /*#__PURE__*/jsx(Button, {
    theme: theme,
    shape: "circle",
    status: "secondary",
    size: "xs",
    onClick: onClick,
    children: clearIcon || /*#__PURE__*/jsx(X, {})
  }, "clearIcon");
};
ClearButton.displayName = 'ClearButton';

export { ClearButton };
